import { classList } from '../../helpers';
import styles from './FormLabel.module.css';

export interface FormLabelProps {
  htmlFor?: string;
  required?: boolean;
  bold?: boolean;
  className?: string;
  children: any;
}

export const FormLabel = (props: FormLabelProps) => {
  return (
    <label
      className={classList(styles.label, props.bold ? styles.bold : undefined, props.className)}
      htmlFor={props.htmlFor}
    >
      {props.children}
      {props.required && <span className={styles.required}>*</span>}
    </label>
  );
};
